import { create } from "zustand";

type ModalState = {
  modals: Record<string, boolean>;
  openModal: (modalName: string) => void;
  closeModal: (modalName: string) => void;
  setModal: (modalName: string, isOpen: boolean) => void;
  toggleModal: (modalName: string) => void;
};

const useModalStore = create<ModalState>((set) => ({
  modals: {},

  openModal: (modalName) =>
    set((state) => ({
      modals: { ...state.modals, [modalName]: true },
    })),

  closeModal: (modalName) =>
    set((state) => ({
      modals: { ...state.modals, [modalName]: false },
    })),

  setModal: (modalName, isOpen) =>
    set((state) => ({
      modals: { ...state.modals, [modalName]: isOpen },
    })),

  toggleModal: (modalName) =>
    set((state) => {
      const current = state.modals[modalName] ?? false;
      return {
        modals: {
          ...state.modals,
          [modalName]: !current,
        },
      };
    }),
}));

export default useModalStore;
